import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link to="/" className="flex items-center gap-2 group">
            <div className="w-9 h-9 md:w-10 md:h-10 bg-primary-500 rounded-lg flex items-center justify-center transition-transform group-hover:scale-105">
              <i className="ri-plant-line text-background-50 text-lg md:text-xl"></i>
            </div>
            <div className="flex flex-col leading-tight">
              <span className="font-heading font-bold text-base md:text-lg text-foreground-900 whitespace-nowrap">
                黄瓜网站
              </span>
              <span className="text-[10px] md:text-xs text-foreground-500 whitespace-nowrap">
                种植·行情·交易
              </span>
            </div>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isActive('/') && !isActive('/category')
                  ? 'bg-primary-100 text-primary-700'
                  : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
              }`}
            >
              首页
            </Link>
            <Link
              to="/category/zhongzhi-jishu"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isActive('/category')
                  ? 'bg-primary-100 text-primary-700'
                  : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
              }`}
            >
              分类浏览
            </Link>
            <Link
              to="/category/shichang-hangqing"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === '/category/shichang-hangqing'
                  ? 'bg-primary-100 text-primary-700'
                  : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
              }`}
            >
              市场行情
            </Link>
            <Link
              to="/about"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isActive('/about')
                  ? 'bg-primary-100 text-primary-700'
                  : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/category/zhongzhi-jishu"
              className="inline-flex items-center gap-1.5 bg-primary-500 hover:bg-primary-600 text-background-50 px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-search-line text-sm"></i>
              搜索文章
            </Link>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-4 py-3">
          <div className="flex flex-col gap-1">
            <Link to="/" className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer">首页</Link>
            <Link to="/category/zhongzhi-jishu" className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer">分类浏览</Link>
            <Link to="/category/shichang-hangqing" className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer">市场行情</Link>
            <Link to="/about" className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer">关于我们</Link>
            <Link to="/category/zhongzhi-jishu" className="mt-2 w-full text-center bg-primary-500 hover:bg-primary-600 text-background-50 px-4 py-3 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer">搜索文章</Link>
          </div>
        </div>
      )}
    </nav>
  );
}